import React, { useState } from "react";
import {
  GeoAltFill,
  TelephoneFill,
  EnvelopeFill,
  Globe,
} from "react-bootstrap-icons";
import "./contact.scss";
import SEO from "../Components/SEO";
import PageHero from '../Components/PageHero'
import { toast } from "react-toastify";
import api from "../admin/api";


function Contact() {
  const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  message: ""
});

const [loading, setLoading] = useState(false);

  // ✅ Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Validation
  const validateForm = () => {
    const { name, phone, email, message } = formData;

    if (!name || !phone || !email || !message) {
      toast.error("All fields are required");
      return false;
    }

    // Email Validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      toast.error("Invalid email format");
      return false;
    }

    // Phone Validation (10 digit India)
    const phonePattern = /^[6-9]\d{9}$/;
    if (!phonePattern.test(phone)) {
      toast.error("Invalid phone number");
      return false;
    }

    return true;
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const res = await api.post("/UiplusContact", formData);

      toast.success(res.data.message || "Message sent successfully");

      // ✅ WhatsApp (optional auto-open)
      const message = `New Inquiry:
Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email}
Message: ${formData.message}`;

      const whatsappUrl = `https://wa.me/918855947070?text=${encodeURIComponent(
        message
      )}`;
      window.open(whatsappUrl, "_blank");

      // ✅ Reset form
      setFormData({
        name: "",
        phone: "",
        email: "",
        message: "",
      });

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    
    <section className="contact-section">

      <SEO
  title="Contact Uiplus Technologies | Software Company in Pune"
  description="Contact Uiplus Technologies for School ERP, Finance Software and custom development solutions."
  keywords="Contact Software Company Pune, School ERP Provider Pune"
  url="https://uiplus.in/contact"
/>
      
      <PageHero
       title="Contact Us"
       subtitle="Get in touch with us"
      />

      <div className="container py-5">

        {/* Section Title */}
        <div className="text-center mb-5">
          <h2 className="section-title" style={{ color:"blue" }}>Contact Us</h2>
          <p className="section-subtitle">
            Get in touch with us for business inquiries and support
          </p>
        </div>

        <div className="row g-4">

          {/* LEFT SIDE - CONTACT INFO */}
          <div className="col-lg-5">
            <div className="contact-card">

              <h4 className="mb-4">Uiplus Technologies</h4>

              <p>
                <GeoAltFill className="contact-icon" />
                Sr.no.31/2/3, Ingale Platinum, Shivane, Pune - 411023
              </p>

              <p>
                <TelephoneFill className="contact-icon" />
                +91 8855947070 / 9158 92 6281
              </p>

              <p>
                <EnvelopeFill className="contact-icon" />
                info@uiplus.in
              </p>

              <p>
                <Globe className="contact-icon" />
                www.uiplus.in
              </p>

            </div>
          </div>

          {/* RIGHT SIDE - CONTACT FORM */}
          <div className="col-lg-7">
            <div className="contact-card">
              <h4 className="mb-4">Send Message</h4>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Your Name"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Contact Number"
                      maxLength="10"
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Email Address"
                  />
                </div>

                <div className="mb-3">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"
                    rows="4"
                    placeholder="Your Message"
                  ></textarea>
                </div>

                {/* ✅ BUTTON WITH LOADER */}
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Sending...
                    </>
                  ) : (
                    "Send Message"
                  )}
                </button>

              </form>
            </div>
          </div>

        </div>

        {/* GOOGLE MAP */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="map-container">
              <iframe
                title="Google Map"
                src="https://www.google.com/maps?q=Pune&output=embed"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Contact;
